import API from "./API";

export default class VariantDAO {
    static getVariantByItemId = async (id) => {
        return await API.request(`/v1/item_variation/item/${id}`, "GET");
    }


}